export default "__VITE_ASSET__65Vmh3Zi__"